// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from '../../../src/integrations/supabase/types';

const SUPABASE_URL = "https://xlepowgirgsayvwhplvw.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhsZXBvd2dpcmdzYXl2d2hwbHZ3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDg2NDg0MDAsImV4cCI6MjA2NDIyNDQwMH0.C4jaohc0dLL3Ia8CR0ESCmNmivQajwi-ZoJwbSN9Sg0";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);